module.exports = __webpack_public_path__ + "img/root010.b02eb049.png";